/* BG Card Swatches – 2025 Best Practice (hardened)
   - Variant deep-linking via ?variant=
   - Hover intent + click update (delegated)
   - Prefetch PDP for perceived speed
   - Safe target normalization to avoid closest() errors
*/
(function () {
    var HOVER_INTENT_MS = 180;
  
    // --- Utilities -------------------------------------------------------------
  
    function toElementTarget(e) {
      var t = e && e.target ? e.target : null;
      // If Text node, get its parent element
      if (t && t.nodeType === 3 && t.parentElement) t = t.parentElement;
      // If still not an Element (e.g., window/document), abort
      return (t && t.nodeType === 1) ? t : null;
    }
  
    function safeClosest(el, selector) {
      if (!el || !selector) return null;
      // Some SVG/foreign elements may not have closest
      if (typeof el.closest === 'function') return el.closest(selector);
      // Fallback: manual traverse
      var cur = el;
      while (cur && cur.nodeType === 1) {
        if (cur.matches && cur.matches(selector)) return cur;
        cur = cur.parentElement;
      }
      return null;
    }
  
    function swapCardImage(cardEl, src, srcset, alt) {
      if (!cardEl) return;
      var media = cardEl.querySelector('.card__media .media');
      if (!media) return;
      var img = media.querySelector('img');
      if (!img) return;
      if (src) img.setAttribute('src', src);
      if (srcset) img.setAttribute('srcset', srcset);
      if (alt) img.setAttribute('alt', alt);
    }
  
    function normalizeUrl(urlString) {
      try {
        var a = document.createElement('a');
        a.href = urlString;
        return new URL(a.href, window.location.origin);
      } catch (e) {
        return null;
      }
    }
  
    function withVariant(urlString, variantId) {
      var u = normalizeUrl(urlString);
      if (!u) {
        var base = (urlString || '').split('#')[0].split('?')[0];
        return base + '?variant=' + encodeURIComponent(String(variantId));
      }
      u.searchParams.delete('variant');
      u.searchParams.set('variant', String(variantId));
      return u.pathname + u.search + u.hash;
    }
  
    function updateCardLinks(cardEl, variantId) {
      if (!cardEl || !variantId) return;
  
      cardEl.querySelectorAll('a.full-unstyled-link, a.product__view-details').forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href) return;
        a.setAttribute('href', withVariant(href, variantId));
      });
  
      cardEl.querySelectorAll('[data-product-url]').forEach(function (el) {
        var url = el.getAttribute('data-product-url');
        if (!url) return;
        el.setAttribute('data-product-url', withVariant(url, variantId));
      });
  
      cardEl.querySelectorAll('[data-url]').forEach(function (el) {
        var url = el.getAttribute('data-url');
        if (!url) return;
        el.setAttribute('data-url', withVariant(url, variantId));
      });
    }
  
    function prefetch(urlString) {
      try {
        var u = normalizeUrl(urlString);
        if (!u) return;
        var href = u.pathname + u.search; // omit hash
        if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
        var link = document.createElement('link');
        link.setAttribute('rel', 'prefetch');
        link.setAttribute('href', href);
        link.setAttribute('as', 'document');
        document.head.appendChild(link);
      } catch (e) {}
    }
  
    function setActive(btn) {
      var card = safeClosest(btn, '.card-wrapper');
      if (!card) return;
      card.querySelectorAll('.card-swatch.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    }
  
    function onSwatchClick(btn) {
      var card = safeClosest(btn, '.card-wrapper');
      if (!card) return;
  
      setActive(btn);
  
      var src = btn.getAttribute('data-image-src');
      var srcset = btn.getAttribute('data-image-srcset');
      var alt = btn.getAttribute('data-image-alt') || '';
      if (src || srcset) swapCardImage(card, src, srcset, alt);
  
      var vid = btn.getAttribute('data-variant-id');
      if (vid) updateCardLinks(card, vid);
    }
  
    function onSwatchHoverIntent(btn) {
      var card = safeClosest(btn, '.card-wrapper');
      if (!card) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
  
      updateCardLinks(card, vid);
  
      var anchor = card.querySelector('a.full-unstyled-link, a.product__view-details');
      if (anchor && anchor.getAttribute('href')) {
        prefetch(withVariant(anchor.getAttribute('href'), vid));
      }
    }
  
    // --- Delegated Events (hardened) ------------------------------------------
  
    function bindDelegatedEvents(root) {
      var hoverTimer = null;
  
      root.addEventListener('click', function (e) {
        var t = toElementTarget(e);
        if (!t) return;
        var btn = safeClosest(t, '.card-swatch');
        if (!btn) return;
        onSwatchClick(btn);
      }, { passive: true });
  
      // Use mouseover/mouseout (bubble) instead of mouseenter/mouseleave (don’t bubble)
      root.addEventListener('mouseover', function (e) {
        var t = toElementTarget(e);
        if (!t) return;
        var btn = safeClosest(t, '.card-swatch');
        if (!btn) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          onSwatchHoverIntent(btn);
        }, HOVER_INTENT_MS);
      }, { passive: true });
  
      root.addEventListener('mouseout', function () {
        clearTimeout(hoverTimer);
      }, { passive: true });
    }
  
    // --- Bootstrapping --------------------------------------------------------
  
    function primeActiveStates() {
      document.querySelectorAll('.card-wrapper').forEach(function (card) {
        var swatches = card.querySelectorAll('.card-swatch');
        if (swatches.length) swatches[0].classList.add('is-active');
      });
    }
  
    function observeGrids() {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var mut = muts[i];
          if (!mut.addedNodes) continue;
          for (var j = 0; j < mut.addedNodes.length; j++) {
            var n = mut.addedNodes[j];
            if (!(n instanceof HTMLElement)) continue;
            if (n.querySelector && (n.matches('.card-wrapper') || n.querySelector('.card-wrapper'))) {
              primeActiveStates();
            }
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  
    function init() {
      primeActiveStates();
      bindDelegatedEvents(document);
      observeGrids();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  